import { Service } from '@turizi/shared';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@mantine/core';
import { useState, cloneElement, ReactElement } from 'react';
import CardModal from '../card-modal';
import { IconSettings, IconCurrencyDollar, IconPercentage, IconEdit, IconReceiptTax } from '@tabler/icons-react';
import { BulkEditPropertiesTab } from './bulk-edit-properties-tab';
import { BulkEditPricesTab } from './bulk-edit-prices-tab';
import { BulkModifyPricesTab } from './bulk-modify-prices-tab';
import { BulkEditDiscountsTab } from './bulk-edit-discounts-tab';
import { BulkEditTaxesTab } from './bulk-edit-taxes-tab';


interface Props {
    services: Service[];
    target: ReactElement;
}

export default function BulkServiceEditModal({ services, target }: Props) {
    const [opened, setOpened] = useState(false);
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<string | null>('properties');

    return (
        <>
            {/* target */}
            {cloneElement(target as ReactElement<any>, { onClick: () => setOpened(true) })}

            {/* modal */}
            <CardModal
                opened={opened}
                onClose={() => setOpened(false)}
                header={t('bulk_edit_services')}
                size="full"
            >
                <Tabs value={activeTab} onChange={setActiveTab}>
                    <Tabs.List>
                        <Tabs.Tab value="properties" leftSection={<IconSettings size={16} />}>
                            {t('edit_properties')}
                        </Tabs.Tab>
                        <Tabs.Tab value="taxes" leftSection={<IconReceiptTax size={16} />}>
                            {t('taxes')}
                        </Tabs.Tab>
                        <Tabs.Tab value="add_price" leftSection={<IconCurrencyDollar size={16} />}>
                            {t('add_price')}
                        </Tabs.Tab>
                        <Tabs.Tab value="modify_price" leftSection={<IconEdit size={16} />}>
                            {t('modify_price')}
                        </Tabs.Tab>
                        <Tabs.Tab value="discounts" leftSection={<IconPercentage size={16} />}>
                            {t('discounts')}
                        </Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel value="properties" pt="md">
                        <BulkEditPropertiesTab services={services} />
                    </Tabs.Panel>

                    <Tabs.Panel value="taxes" pt="md">
                        <BulkEditTaxesTab services={services} />
                    </Tabs.Panel>

                    <Tabs.Panel value="add_price" pt="md">
                        <BulkEditPricesTab services={services} />
                    </Tabs.Panel>

                    <Tabs.Panel value="modify_price" pt="md">
                        <BulkModifyPricesTab services={services} />
                    </Tabs.Panel>

                    <Tabs.Panel value="discounts" pt="md">
                        <BulkEditDiscountsTab services={services} />
                    </Tabs.Panel>

                </Tabs>
            </CardModal>
        </>
    );
}
